// import { Font } from '@ckeditor/ckeditor5-font';

export let EDITOR_CONFIG = {
  // plugins: [Font],
  toolbar: [
    'undo',
    'redo',
    '|',
    'fontsize',
    'fontColor',
    'fontBackgroundColor',
    '|',
    'bold',
    'italic',
    '|',
    'link',
    '|',
    'numberedList',
    'bulletedList',
    'outdent',
    'indent',
  ],
  licenseKey:'GPL'
};
